import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PriceBreakdownSection',
  props: {
    section: null
  },
  setup(__props: any) {


const getItemRows = (item: { from?: { title: string; price?: string }; to?: { title: string; price?: string } }) => {
	const rows = [];
	if (item.from) {
		rows.push({ title: item.from.title, price: item.from.price });
	}
	if (item.to) {
		rows.push({ title: item.to.title, price: item.to.price });
	}
	return rows;
};

return { __sfc: true,getItemRows }
}

})